// extracted by mini-css-extract-plugin
export default {"checkboxtext":"CustomCheckbox_checkboxtext__p-axh","checkboxcontainer":"CustomCheckbox_checkboxcontainer__o9oes","checkbox":"CustomCheckbox_checkbox__rOdcc"};